import React from 'react';

// ServiceItem component to represent a single service
const ServiceItem = ({ iconClass, altText, title, description, highlightText }) => (
  <div className="col-xs-12 col-sm-6 col-md-4 home6">
    <div className="singleService">
      <div className="serviceImgArea text-center">
        {/* Use <i> tag to display Font Awesome icons */}
        <i className={iconClass} alt={altText}></i>
      </div>
      <div className="serviceContent">
        <h5>{title}</h5>
        <p>
          {description.split(highlightText).map((text, index, array) => (
            index === array.length - 1 ? text : <>
              {text}<span>{highlightText}</span>
            </>
          ))}
        </p>
      </div>
    </div>
  </div>
);

// ServicesSection component to represent the entire section
const Types = () => {
  const services = [
    {
      iconClass: "fas fa-cogs fs-1",  // Font Awesome icon for gear (Aluminium Glass Office Partition)
      altText: "Glass Office Partition",
      title: "All Types of Aluminium Glass Office Partition",
      description: "Anjali Enterprises offers top-quality aluminium glass office partitions, tailored to your office design and space requirements.",
      highlightText: "aluminium glass office partition",
    },
    {
      iconClass: "fas fa-shield-alt fs-1",  // Font Awesome icon for shield (Toughened Glass Work)
      altText: "Toughened Glass Work",
      title: "All Types of Toughened Glass Work",
      description: "We provide expert installation and maintenance for all types of toughened glass work, ensuring durability and safety.",
      highlightText: "toughened glass work",
    },
    {
      iconClass: "fas fa-door-open fs-1",  // Font Awesome icon for door (Door Partition)
      altText: "Door Partition",
      title: "All Types of Door Partition",
      description: "Anjali Enterprises specializes in door partitions that provide privacy and optimize space, available for residential and commercial purposes.",
      highlightText: "door partition",
    },
    {
      iconClass: "fas fa-building fs-1",  // Font Awesome icon for building (ACP Cladding Panel Installation)
      altText: "ACP Cladding Panel Installation",
      title: "ACP Cladding Panel Installation",
      description: "Our ACP cladding panel installation services ensure modern and sleek exteriors for your building, enhancing its visual appeal.",
      highlightText: "ACP cladding panel installation",
    },
    {
      iconClass: "fas fa-window-maximize fs-1",  // Font Awesome icon for window (Aluminium Glass Window)
      altText: "Aluminium Glass Window",
      title: "All Types of Aluminium Glass Window",
      description: "We design and install high-quality aluminium glass windows, enhancing natural light and providing an elegant look for your spaces.",
      highlightText: "aluminium glass window",
    },
    {
      iconClass: "fas fa-volume-up fs-1",  // Font Awesome icon for sound (Soundproof Glass Window)
      altText: "Soundproof Glass Window",
      title: "All Types of Soundproof Glass Window",
      description: "Our soundproof glass windows offer a quiet environment, making them ideal for both residential and commercial applications.",
      highlightText: "soundproof glass window",
    },
    {
      iconClass: "fas fa-bug fs-1",  // Font Awesome icon for insect (Aluminium Mosquito Net)
      altText: "Aluminium Mosquito Net",
      title: "All Types of Aluminium Mosquito Net",
      description: "Protect your space from pests with our durable and efficient aluminium mosquito nets, providing comfort and safety.",
      highlightText: "aluminium mosquito net",
    },
    {
      iconClass: "fas fa-grip-lines-vertical fs-1 ",  // Font Awesome icon for vertical grill (Invisible Grill Installation)
      altText: "Invisible Grill Installation",
      title: "Invisible Grill Installation",
      description: "Invisible grill installations by Anjali Enterprises offer enhanced security while maintaining the aesthetic appeal of your property.",
      highlightText: "invisible grill installation",
    },
    {
      iconClass: "fas fa-door-closed fs-1",  // Font Awesome icon for closed door (MS Fabrication Door)
      altText: "MS Fabrication Door",
      title: "MS Fabrication Door",
      description: "Our MS fabrication doors provide strength and durability, offering a safe and stylish solution for both residential and commercial properties.",
      highlightText: "MS fabrication door",
    },
    {
      iconClass: "fas fa-sun fs-1",  // Font Awesome icon for sun (MS Fabrication Shade)
      altText: "MS Fabrication Shade",
      title: "MS Fabrication Shade",
      description: "We offer MS fabrication shades to protect against the sun, perfect for commercial and residential installations.",
      highlightText: "MS fabrication shade",
    },
    {
      iconClass: "fas fa-lock fs-1",  // Font Awesome icon for lock (MS Fabrication Grill)
      altText: "MS Fabrication Grill",
      title: "MS Fabrication Grill",
      description: "Our MS fabrication grills provide enhanced security while adding a decorative element to your windows and doors.",
      highlightText: "MS fabrication grill",
    },
  ];

  return (
    <section className="paddingSection serviceSection Seccc text-center">
      <div className="container Seccc">
        <div className="row">
          {/* Title Section */}
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="titleHead">
              <div className="tophead">
                <div className="line"></div>
                <p>ABOUT INDOFACT INDUSTRY</p>
              </div>
              <h1>Our Services & Solutions</h1>
            </div>
          </div>

          {/* Service List */}
          {services.map((service, index) => (
            <ServiceItem className="fs-5"
              key={index}
              iconClass= {service.iconClass}  // Pass iconClass to ServiceItem
              altText={service.altText}
              title={service.title}
              description={service.description}
              highlightText={service.highlightText}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Types;
